import styled from 'styled-components'

export const Scrollable = styled.div.attrs({
  className: 'scrollable',
})`
  overflow-y: auto;
  height: 100%;
`

interface IHeightAdjuster {
  shrink: string
}
export const HeightAdjuster = styled.div<IHeightAdjuster>`
  height: ${({ shrink }) => `calc(100% - ${shrink})`};
`
